import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import UserListService from '../services/userListService';
import { UserListFilter, UserListRequest, UserListState } from '../types/UserList';

const initialState: UserListState = {
  items: [],
  status: ['invited', 'registered'],
  filter: null,
  sort: { field: 'status', direction: 'asc' },
  limit: 20,
  nextCursor: null,
  cursorHistory: [],
  loading: false,
  error: null,
};

export const fetchUsers = createAsyncThunk(
  'userList/fetchUsers',
  async (request: UserListRequest) => UserListService.getInstance().query(request)
);

const userListSlice = createSlice({
  name: 'userList',
  initialState,
  reducers: {
    setStatus: (state, action: PayloadAction<string[]>) => {
      state.status = action.payload;
      state.cursorHistory = [];
      state.nextCursor = null;
    },
    setFilter: (state, action: PayloadAction<UserListFilter>) => {
      state.filter = action.payload;
      state.cursorHistory = [];
      state.nextCursor = null;
    },
    setSortDirection: (state, action: PayloadAction<'asc' | 'desc'>) => {
      state.sort.direction = action.payload;
      state.cursorHistory = [];
      state.nextCursor = null;
    },
    setLimit: (state, action: PayloadAction<number>) => {
      state.limit = action.payload;
      state.cursorHistory = [];
      state.nextCursor = null;
    },
    resetUserList: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUsers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUsers.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload.items;
        state.nextCursor = action.payload.nextCursor;
      })
      .addCase(fetchUsers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to load users';
      });
  },
});

export const { setStatus, setFilter, setSortDirection, setLimit, resetUserList } = userListSlice.actions;
export default userListSlice.reducer;
